// ========================================================================================================== FOOTER
// ===================================================== SCROLLTRIGGER
gsap.set('.co-svg-footer-logo-mountains', { yPercent: 18 });
// gsap.set('.co-footer-mountains-item-2', { yPercent: 16 });
// gsap.set('.co-footer-mountains-item-3', { yPercent: 14 });
// gsap.set('.co-footer-mountains-item-4', { yPercent: 12 });
// gsap.set('.co-footer-mountains-item-5', { yPercent: 10 });
// gsap.set('.co-footer-mountains-item-1 img', { xPercent: -0.9 });
// gsap.set('.co-footer-mountains-item-2 img', { xPercent: 0.8 });
// gsap.set('.co-footer-mountains-item-3 img', { xPercent: -0.7 });
// gsap.set('.co-footer-mountains-item-4 img', { xPercent: 0.6 });
// gsap.set('.co-footer-mountains-item-5 img', { xPercent: -0.5 });
let coFooterMountainsScrubStart = "50% bottom";
let coFooterMountainsScrubEnd = "bottom top";
gsap.to('.co-svg-footer-logo-mountains', {
  scrollTrigger: {
    trigger: '.co-main-footer-wrapper', start: coFooterMountainsScrubStart, end: coFooterMountainsScrubEnd, scrub: 2.5
  },
  yPercent: 0
});

// gsap.to('.co-footer-mountains-item-2', {
//   scrollTrigger: {
//     trigger: '.co-main-footer-wrapper', start: coFooterMountainsScrubStart, end: coFooterMountainsScrubEnd, scrub: 2.2
//   },
//   yPercent: 0
// });
// gsap.to('.co-footer-mountains-item-3', {
//   scrollTrigger: {
//     trigger: '.co-main-footer-wrapper', start: coFooterMountainsScrubStart, end: coFooterMountainsScrubEnd, scrub: 1.9
//   },
//   yPercent: 0
// });
// gsap.to('.co-footer-mountains-item-4', {
//   scrollTrigger: {
//     trigger: '.co-main-footer-wrapper', start: coFooterMountainsScrubStart, end: coFooterMountainsScrubEnd, scrub: 1.6
//   },
//   yPercent: 0
// });
// gsap.to('.co-footer-mountains-item-5', {
//   scrollTrigger: {
//     trigger: '.co-main-footer-wrapper', start: coFooterMountainsScrubStart, end: coFooterMountainsScrubEnd, scrub: 1.3
//   },
//   yPercent: 0,
//   xPercent: 0
// });
// gsap.to('.co-footer-mountains-item-1 img', {
//   scrollTrigger: {
//     trigger: '.co-main-footer-wrapper', start: coFooterMountainsScrubStart, end: coFooterMountainsScrubEnd, scrub: 1.8
//   },
//   xPercent: 0
// });
// gsap.to('.co-footer-mountains-item-2 img', {
//   scrollTrigger: {
//     trigger: '.co-main-footer-wrapper', start: coFooterMountainsScrubStart, end: coFooterMountainsScrubEnd, scrub: 1.6
//   },
//   xPercent: 0
// });
// gsap.to('.co-footer-mountains-item-3 img', {
//   scrollTrigger: {
//     trigger: '.co-main-footer-wrapper', start: coFooterMountainsScrubStart, end: coFooterMountainsScrubEnd, scrub: 1.4
//   },
//   xPercent: 0
// });
// gsap.to('.co-footer-mountains-item-4 img', {
//   scrollTrigger: {
//     trigger: '.co-main-footer-wrapper', start: coFooterMountainsScrubStart, end: coFooterMountainsScrubEnd, scrub: 1.2
//   },
//   xPercent: 0
// });
// gsap.to('.co-footer-mountains-item-5 img', {
//   scrollTrigger: {
//     trigger: '.co-main-footer-wrapper', start: coFooterMountainsScrubStart, end: coFooterMountainsScrubEnd, scrub: 1
//   },
//   xPercent: 0
// });
// ========================================================================================================== DRIP LOADING ANIMATION
const coFooterTargetElement = document.querySelector('.co-footer-right-form-embed>div');
const coFooterLoaderElement = document.querySelector('.co-footer-right-form-embed-loading');
const coFooterEmbedElement = document.querySelector('.co-footer-right-form-embed');
const coFooterObserverCallback = function(mutationsList, coFooterObserver) {
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            yourActionFunction();
            coFooterObserver.disconnect();
        }
    }
};
const coFooterObserver = new MutationObserver(coFooterObserverCallback);
coFooterObserver.observe(coFooterTargetElement, { childList: true });
function yourActionFunction() {
    coFooterLoaderElement.classList.add('co-drip-loaded');
    coFooterEmbedElement.classList.add('co-drip-loaded');
}
